import { useTranslation } from "react-i18next"

export function getBackgroundStyle(refund) {
    switch (refund.status) {
        case "SENT": return "bg-dark bg-opacity-25"
        case "ACCEPTED": return "bg-success bg-opacity-25"
        case "INCOMPLETE": return "bg-warning bg-opacity-10"
        case "UPDATED": return "bg-primary bg-opacity-10"
        case "CANCELED": return "bg-dark opacity-50"
        default: return "bg-dark bg-opacity-25"
    }
}

export function getStatusIcon(refund) {
    switch (refund.status) {
        case "SENT": return <i className="fa-solid fa-circle-play"></i>
        case "ACCEPTED": return <i className="fa-solid fa-circle-check"></i>
        case "INCOMPLETE": return <i className="fa-solid fa-triangle-exclamation"></i>
        case "UPDATED": return <i className="fa-solid fa-arrows-rotate"></i>
        case "CANCELED": return <i className="fa-solid fa-circle-xmark"></i>
        case "DELETED": return <i className="fa-solid fa-trash"></i>
        default: return
    }
}

export function getStatusLabel(refund, translation) {
    switch (refund.status) {
        case "SENT": return translation("absenceReport:entity.costRefund.status.sent")
        case "ACCEPTED": return translation("absenceReport:entity.costRefund.status.accepted")
        case "INCOMPLETE": return translation("absenceReport:entity.costRefund.status.incomplete")
        case "UPDATED": return translation("absenceReport:entity.costRefund.status.updated")
        case "CANCELED": return translation("absenceReport:entity.costRefund.status.canceled")
        case "DELETED": return translation("absenceReport:entity.costRefund.status.deleted")
        default: return
    }
}


export function canBeAccepted(refund) {
    return refund.status == "INCOMPLETE" || refund.status == "SENT" || refund.status == "UPDATED"
}

export function canBeDeleted(refund) {
    return refund.status != "DELETED"
}

export function canBeCorrected(refund) {
    return refund.status == "INCOMPLETE"
}

export function canBeMarkedAsIncomplete(refund) {
    return refund.status == "UPDATED" || refund.status == "SENT"
}

